import PropTypes from 'prop-types'
import Clickable from 'components/clickable'
import { ListBox } from 'components/list-box'
import { getSearchHistory, searchStore, getPopularSearches } from '../helpers'

const SearchHistory = ({ onSearch, inFocus, onBlur }) => {
  const searchHistory = getSearchHistory()
  const showHistory = searchHistory.length > 0
  const items = showHistory ? searchHistory : getPopularSearches()

  return (
    <>
      <p>{`${showHistory ? 'Recent' : 'Popular'} Searches:`}</p>
      <ListBox
        inFocus={inFocus}
        name="Recent Searches"
        options={items.map((item) => ({
          value: item,
          element: (
            <Clickable
              className="link bold"
              onClick={() => searchStore(item, onSearch)}
            >
              {item}
            </Clickable>
          ),
        }))}
        onBlur={onBlur}
        onSelect={(item) => searchStore(item, onSearch)}
      />
    </>
  )
}

SearchHistory.propTypes = {
  onBlur: PropTypes.func.isRequired,
  inFocus: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default SearchHistory
